import { Injectable } from '@angular/core';
import { map } from "rxjs/operators";
import { ScreensService } from "../../../theme/screens/screens.service";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiConfigService } from '../../../shared-services/api-config.service';
import { BehaviorSubject } from 'rxjs';
import { SiteDto } from '../../../dtos/siteDto';
import { MonumentsDataService } from "./monuments-data.service";
import { MonumentDto } from '../../../dtos/monumentDto';

@Injectable({
    providedIn: 'root'
})
export class SitesDataService {

    private _sites: BehaviorSubject<Array<SiteDto>> = new BehaviorSubject<any>([]);
    public readonly sites: Observable<Array<SiteDto>> = this._sites.asObservable();

    constructor(private apiConfigService: ApiConfigService) {
        const subscription = this.apiConfigService.get('api/site/all')
            .pipe(
                tap((values: any) => {
                    this._sites.next(values);
                    subscription.unsubscribe();
                })
            )
            .subscribe()
    }


    //Static synchronous access of observable. Beware you are responsible to know that the data has been fetched.
    getSiteData(): Array<SiteDto> {
        return this._sites.getValue();
    };

    getSiteById(siteId: number):Observable<SiteDto> {
        return this._sites.pipe(
            map((sites:Array<SiteDto>)=> sites.find((site:SiteDto)=>site.id === Number(siteId)))
        );
    }

}